export default {
  register: 'Sign up'
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/login.js